import { Grid, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";

const TabPanel4 = ({ data }: any) => {
  const { t } = useTranslation(["operation"]);
  return (
    <Grid container spacing={3}>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="purchaseGroup"
          name="purchaseGroup"
          label={t("vehicle.tabPanel4.purchaseGroup")}
          value={data.purchaseGroup}
        />
        <TextField
          fullWidth
          disabled
          id="colorExt"
          name="colorExt"
          label={t("vehicle.tabPanel4.colorExt")}
          value={data.colorExt}
        />
        <TextField
          fullWidth
          disabled
          id="colorInt"
          name="colorInt"
          label={t("vehicle.tabPanel4.colorInt")}
          value={data.colorInt}
        />
		<TextField
          fullWidth
          disabled
          id="freeTextCode"
          name="freeTextCode"
          label={t("vehicle.tabPanel4.freeTextCode")}
          value={data.freeTextCode}
        />

      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="fleetDays"
          name="fleetDays"
          label={t("vehicle.tabPanel4.fleetDays")}
          value={data.fleetDays}
        />
        <DatePicker
          label={t("vehicle.tabPanel4.fleetMinDatetime")}
          disabled
          inputFormat="DD-MM-YYYY"
          value={!!data.fleetMinDate ? data.fleetMinDate : null}
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
        <DatePicker
          label={t("vehicle.tabPanel4.fleetMaxDatetime")}
          disabled
          inputFormat="DD-MM-YYYY"
          value={!!data.fleetMaxDate ? data.fleetMaxDate : null}
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
        <TextField
          fullWidth
          disabled
          id="eTollNumber"
          name="eTollNumber"
          label={t("vehicle.tabPanel4.eTollNumber")}
          value={data.currentEtoll?.number}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="insuranceDescr"
          name="insuranceDescr"
          label={t("insurance.description")}
          value={data.insurance.descr}
        />
        <TextField
          fullWidth
          disabled
          id="insuranceCode"
          name="insuranceCode"
          label={t("insurance.code")}
          value={data.insurance.code}
        />
        <DatePicker
          label={t("vehicle.tabPanel4.insuranceExpirationDate")}
          disabled
          inputFormat="DD-MM-YYYY"
          value={
            !!data.insuranceExpirationDate ? data.insuranceExpirationDate : null
          }
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
        <DatePicker
          label={t("vehicle.tabPanel4.eTollLinkDate")}
          disabled
          inputFormat="DD-MM-YYYY"
          value={!!data.currentEtoll?.number ? data.currentEtoll?.linkDatetime : null}
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
      </Grid>
      <Grid item xs={3}>
        <DatePicker
          label={t("vehicle.tabPanel4.carTaxExpirationDate")}
          disabled
          inputFormat="DD-MM-YYYY"
          value={!!data.carTaxExpirationDate ? data.carTaxExpirationDate : null}
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
		 <TextField
          fullWidth
          disabled
          id="rfidCardNumber"
          name="rfidCardNumber"
          label={t("vehicle.tabPanel4.rfidCardNumber")}
          value={data.currentRfidCard?.number}
        />
        <DatePicker
          label={t("vehicle.tabPanel4.rfidCardActivationDate")}
          disabled
          inputFormat="DD-MM-YYYY"
          value={!!data.currentRfidCard?.activationDatetime ? data.currentRfidCard?.activationDatetime : null}
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />

      </Grid>
    </Grid>
  );
};
export default TabPanel4;
